import { render, staticRenderFns } from "./CarbonfootprintDetail.vue?vue&type=template&id=60dff19c&scoped=true"
import script from "./CarbonfootprintDetail.vue?vue&type=script&lang=js"
export * from "./CarbonfootprintDetail.vue?vue&type=script&lang=js"
import style0 from "./CarbonfootprintDetail.vue?vue&type=style&index=0&id=60dff19c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dff19c",
  null
  
)

export default component.exports